// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { miniSignInStyles } from "@west/App/Components/MiniSignIn/MiniSignIn";
import Close from "@west/XDL/Icons/Close";
import { color, styledScrollbar } from "@west/XDL/Utilities";
import { css } from "styled-components";

miniSignInStyles.container = {
    css: css`
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        overflow-y: auto;
        ${({ headerHeight }: any) =>
            headerHeight
                ? css`
                      max-height: calc(100vh - ${headerHeight});
                  `
                : css`
                      max-height: 100vh;
                  `}

        padding: 6px 16px 30px;
        margin-top: 4px;

        ${styledScrollbar()}
    `,
};

miniSignInStyles.divider = {
    css: css`
        margin: 32px 0;
        width: 100%;
        border: 1px solid ${color("common.border")};
    `,
};

miniSignInStyles.closeClickable = {
    css: css`
        position: absolute;
        right: 17px;

        &:focus {
            outline: none;
        }
        ${IconWrapper}, ${IconWrapper}> svg {
            width: 12px;
            height: 18px;
        }

        &:hover > ${IconWrapper} {
            color: ${color("common.ui9")};
        }
    `,
};
miniSignInStyles.closeIcon = {
    src: Close,
};
